import React from 'react';
import { Row, Column } from '../Grid';
import * as styles from './last-modified-date.module.scss';

export interface LastModifiedDateProps {
    date: number | string | Date;
}

export default function LastModifiedDate({ date }: LastModifiedDateProps) {
    const lastModified = new Date(date);

    return date ? (
        <Row className={styles.row}>
            <Column>
                <div className={styles.text}>
                    {/* // https://www-03preprod.ibm.com/support/knowledgecenter/ibm_style/dates-and-times.html */}
                    Page last updated:&nbsp;
                    {lastModified.toLocaleDateString('en-GB', {
                        day: '2-digit',
                        year: 'numeric',
                        month: 'long',
                    })}
                </div>
            </Column>
        </Row>
    ) : null;
}
